module.exports = __webpack_public_path__ + "static/logo-white-bf21e4f061817a7a814480de86efefdf.png";